import { Component } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
@Component({
  selector: 'app-analytics-home',
  templateUrl: './analytics-home.component.html',
  styleUrls: ['./analytics-home.component.css']
})
export class AnalyticsHomeComponent{
  
  // filter={
  //   metricId:null,
  //   amount:null,
  //   dateFor:null,
  //   frequency:null
  //  }
  messagefromfilter : any ="";
  userData:any=[];
  constructor(private accountservice:AccountService) {
    
   }
  

  ngOnInit() {
//     this.accountservice.getfilterdata().subscribe(data=>{ //i added ------------------
     
//      console.log("filterdata",data)
      
// })
  
    
  }

}
